module.exports = __webpack_public_path__ + "static/img/thumbnail.d9fbe98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911263/thumbnail.jpg
// module id = NIhq
// module chunks = 1